// extracted by mini-css-extract-plugin
module.exports = {"label":"Top_label___XNbF","delete":"Top_delete__7bzaF","disabled":"Top_disabled__0jN_a"};